package com.ustadmobile.xmlpullparserkmp

actual fun XmlPullParser.setInputString(xmlString: String) = setInput(xmlString)
